import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Reference, Property, Name, Output, Text } from "@components/Reference";
import Sandbox from "@components/Sandbox";
import { Spacer } from "@cleartrip/bento/lib";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "typography"
    }}>{`Typography`}</h1>
    <p>{`Utility classes for all typography elements.`}</p>
    <h2 {...{
      "id": "font-family"
    }}>{`Font family`}</h2>
    <p>{`Bento uses three font stacks. Use these classes `}<inlineCode parentName="p">{`ff-sans-serif`}</inlineCode>{`, `}<inlineCode parentName="p">{`ff-serif`}</inlineCode>{` and `}<inlineCode parentName="p">{`ff-mono`}</inlineCode>{` to change the `}<inlineCode parentName="p">{`font-family`}</inlineCode></p>
    <Spacer my={8} mdxType="Spacer" />
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <span className="ff-sans-serif fs-body-3 d-block">Millimeter</span>
    <span className="ff-serif fs-body-3 d-block">Millimeter</span>
    <span className="ff-mono fs-body-3 d-block">Millimeter</span>
  </Sandbox.Preview>
  <Sandbox.Code>
    <p className="ff-sans-serif">...</p>
    <p className="ff-serif">...</p>
    <p className="ff-mono">...</p>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "font-size"
    }}>{`Font size`}</h2>
    <p>{`Bento's type scale has the following classes to change the font size of an element. Use it in combination with font weight and line height for better harmony.`}</p>
    <Reference mdxType="Reference">
  <Property mdxType="Property">
    <Name mdxType="Name">.fs-1</Name>
    <Output mdxType="Output">font-size:10px;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.fs-2</Name>
    <Output mdxType="Output">font-size:12px;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.fs-3</Name>
    <Output mdxType="Output">font-size:14px;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.fs-4</Name>
    <Output mdxType="Output">font-size:16px;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.fs-5</Name>
    <Output mdxType="Output">font-size:18px;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.fs-6</Name>
    <Output mdxType="Output">font-size:20px;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.fs-7</Name>
    <Output mdxType="Output">font-size:24px;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.fs-8</Name>
    <Output mdxType="Output">font-size:28px;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.fs-9</Name>
    <Output mdxType="Output">font-size:32px;</Output>
  </Property>
    </Reference>
    <Spacer my={8} mdxType="Spacer" />
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <span className="fs-display d-block">Millimeter</span>
    <span className="fs-heading-3 d-block">Millimeter</span>
    <span className="fs-heading-2 d-block">Millimeter</span>
    <span className="fs-heading d-block">Millimeter</span>
    <span className="fs-body-3 d-block">Millimeter</span>
    <span className="fs-body-2 d-block">Millimeter</span>
    <span className="fs-body d-block">Millimeter</span>
    <span className="fs-caption-2 d-block">Millimeter</span>
    <span className="fs-caption d-block">Millimeter</span>
  </Sandbox.Preview>
  <Sandbox.Code>
    <p className="fs-9">...</p>
    <p className="fs-2">...</p>. . .<p className="fs-1">...</p>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "font-weight"
    }}>{`Font weight`}</h2>
    <p>{`The available range of weights is `}<inlineCode parentName="p">{`100`}</inlineCode>{`(Ultra thin) to `}<inlineCode parentName="p">{`900`}</inlineCode>{`(Black).
Some of the commonly used weights are `}<inlineCode parentName="p">{`.fw-400`}</inlineCode>{`, `}<inlineCode parentName="p">{`.fw-500`}</inlineCode>{`, `}<inlineCode parentName="p">{`.fw-600`}</inlineCode>{` and `}<inlineCode parentName="p">{`.fw-800`}</inlineCode></p>
    <Spacer my={8} mdxType="Spacer" />
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <span className="fs-body-3 d-block fw-800">Millimeter</span>
    <span className="fs-body-3 d-block fw-600">Millimeter</span>
    <span className="fs-body-3 d-block fw-500">Millimeter</span>
    <span className="fs-body-3 d-block fw-400">Millimeter</span>
  </Sandbox.Preview>
  <Sandbox.Code>
    <p className="fw-800">...</p>
    <p className="fw-600">...</p>
    <p className="fw-500">...</p>
    <p className="fw-400">...</p>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "line-height"
    }}>{`Line height`}</h2>
    <p>{`Change the line height density with these classes.`}</p>
    <Reference mdxType="Reference">
  <Property mdxType="Property">
    <Name mdxType="Name">.lh-solid</Name>
    <Output mdxType="Output">line-height:1;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.lh-title</Name>
    <Output mdxType="Output">line-height:1.25;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.lh-copy</Name>
    <Output mdxType="Output">line-height:1.5;</Output>
  </Property>
  </Reference>
    <Spacer my={8} mdxType="Spacer" />
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <span className="c-neutral-800 m-0 lh-solid d-block">
      <strong>Line height of this paragraph is set to 1.</strong> The quick
      brown fox jumped over the lazy dog. Lorem ipsum dolor sit amet,
      consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
      dolore magna aliqua.
    </span>
  </Sandbox.Preview>
  <Spacer my={4} mdxType="Spacer" />
  <Sandbox.Preview>
    <span className="c-neutral-800 m-0 lh-title d-block">
      <strong>Line height of this paragraph is set to 1.25.</strong>The quick
      brown fox jumped over the lazy dog. Lorem ipsum dolor sit amet,
      consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
      dolore magna aliqua.
    </span>
  </Sandbox.Preview>
  <Spacer my={4} mdxType="Spacer" />
  <Sandbox.Preview>
    <span className="c-neutral-800 m-0 lh-copy d-block">
      <strong>Line height of this paragraph is set to 1.5.</strong>The quick
      brown fox jumped over the lazy dog. Lorem ipsum dolor sit amet,
      consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
      dolore magna aliqua.
    </span>
  </Sandbox.Preview>
  <Sandbox.Code>
    <p className="lh-solid">...</p>
    <p className="lh-title">...</p>
    <p className="lh-copy">...</p>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={8} mdxType="Spacer" />
    <p>{`Additionally, `}<inlineCode parentName="p">{`.lh-none`}</inlineCode>{` sets the `}<inlineCode parentName="p">{`line-height`}</inlineCode>{` to `}<inlineCode parentName="p">{`0`}</inlineCode>{`. It's best to not use it unless needed for a specific usecase.`}</p>
    <h2 {...{
      "id": "font-style"
    }}>{`Font style`}</h2>
    <p>{`This property allows you to make text appear italicized. By default the `}<inlineCode parentName="p">{`font-style`}</inlineCode>{` is set to `}<inlineCode parentName="p">{`normal`}</inlineCode></p>
    <Reference mdxType="Reference">
  <Property mdxType="Property">
    <Name mdxType="Name">.fs-italic</Name>
    <Output mdxType="Output">font-style:italic;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.fs-normal</Name>
    <Output mdxType="Output">font-style:normal;</Output>
  </Property>
    </Reference>
    <Spacer my={8} mdxType="Spacer" />
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <span className="fs-body-3 d-block fw-400 fs-italic">Millimeter</span>
    <span className="fs-body-3 d-block fw-400 fs-normal">Millimeter</span>
  </Sandbox.Preview>
  <Sandbox.Code>
    <p className="fs-italic">...</p>
    <p className="fs-normal">...</p>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "text-decoration"
    }}>{`Text decoration`}</h2>
    <p>{`Change the appearance of the decorative lines using these classes.`}</p>
    <Reference mdxType="Reference">
  <Property mdxType="Property">
    <Name mdxType="Name">.td-underline</Name>
    <Output mdxType="Output">text-decoration: underline;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.td-none</Name>
    <Output mdxType="Output">text-decoration: none;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.td-line-through</Name>
    <Output mdxType="Output">text-decoration: line-through;</Output>
  </Property>
    </Reference>
    <Spacer my={8} mdxType="Spacer" />
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <span className="fs-body-3 d-block td-underline">Millimeter</span>
    <span className="fs-body-3 d-block td-none">Millimeter</span>
    <span className="fs-body-3 d-block td-line-through">Millimeter</span>
  </Sandbox.Preview>
  <Sandbox.Code>
    <p className="td-underline">...</p>
    <p className="td-none">...</p>
    <p className="td-line-through">...</p>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "text-align"
    }}>{`Text align`}</h2>
    <p>{`Change the alignment of the text using these classes.`}</p>
    <Reference mdxType="Reference">
  <Property mdxType="Property">
    <Name mdxType="Name">.ta-left</Name>
    <Output mdxType="Output">text-align: left;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.ta-right</Name>
    <Output mdxType="Output">text-align: left;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.ta-center</Name>
    <Output mdxType="Output">text-align: center;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.ta-justify</Name>
    <Output mdxType="Output">text-align: justify;</Output>
  </Property>
    </Reference>
    <Spacer my={8} mdxType="Spacer" />
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-inline-block h-11 bg-secondary-100 w-100p clearfix ta-left">
      <span className="fs-body-3">Hello</span>
    </div>
  </Sandbox.Preview>
  <Spacer my={4} mdxType="Spacer" />
  <Sandbox.Preview>
    <div className="d-inline-block h-11 bg-secondary-100 w-100p clearfix ta-right">
      <span className="fs-body-3">Hello</span>
    </div>
  </Sandbox.Preview>
  <Spacer my={4} mdxType="Spacer" />
  <Sandbox.Preview>
    <div className="d-inline-block h-11 bg-secondary-100 w-100p clearfix ta-center">
      <span className="fs-body-3">Hello</span>
    </div>
  </Sandbox.Preview>
  <Spacer my={4} mdxType="Spacer" />
  <Sandbox.Preview>
    <div className="d-inline-block h-11 bg-secondary-100 w-100p clearfix ta-justify">
      <span className="fs-body-2">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua.
      </span>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="ta-left">...</div>
    <div className="ta-right">...</div>
    <div className="ta-center">...</div>
    <div className="ta-justify">...</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "font-smoothing"
    }}>{`Font smoothing`}</h2>
    <p>{`This property controls the application of anti-aliasing when fonts are rendered.`}</p>
    <Reference mdxType="Reference">
  <Property mdxType="Property">
    <Name mdxType="Name">.fs-antialiased</Name>
    <Output mdxType="Output">font-smoothing: antialiased;</Output>
  </Property>
    </Reference>
    <Spacer my={8} mdxType="Spacer" />
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <span className="fs-body-2 d-block fs-antialiased">Antialiased</span>
  </Sandbox.Preview>
  <Sandbox.Code>
    <p className="fs-antialiased">...</p>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "letter-spacing"
    }}>{`Letter spacing`}</h2>
    <p>{`Defines the spacing between the characters of a block of text.`}</p>
    <Reference mdxType="Reference">
  <Property mdxType="Property">
    <Name mdxType="Name">.ls-tight</Name>
    <Output mdxType="Output">letter-spacing: -1px;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.ls-normal</Name>
    <Output mdxType="Output">letter-spacing: 0px;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.ls-wide</Name>
    <Output mdxType="Output">letter-spacing: 1px;</Output>
  </Property>
    </Reference>
    <Spacer my={8} mdxType="Spacer" />
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <span className="fs-body-2 d-block ls-tight">
      Tightly letter-spaced at -1px
    </span>
  </Sandbox.Preview>
  <Spacer my={4} mdxType="Spacer" />
  <Sandbox.Preview>
    <span className="fs-body-2 d-block ls-normal">
      No additional letter-spacing applied
    </span>
  </Sandbox.Preview>
  <Spacer my={4} mdxType="Spacer" />
  <Sandbox.Preview>
    <span className="fs-body-2 d-block ls-wide">
      Loosely letter-spaced at 1px
    </span>
  </Sandbox.Preview>
  <Sandbox.Code>
    <p className="ls-tight">...</p>
    <p className="ls-normal">...</p>
    <p className="ls-wide">...</p>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "text-color"
    }}>{`Text color`}</h2>
    <p>{`The color of the text can be changed by adding the color variables/classes.`}</p>
    <Reference mdxType="Reference">
  <Property mdxType="Property">
    <Name mdxType="Name">.c-primary-500</Name>
    <Output mdxType="Output">color: #F77728;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.c-secondary-500</Name>
    <Output mdxType="Output">color: #3366CC;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.c-tertiary-500</Name>
    <Output mdxType="Output">color: #37404E;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.c-success-500</Name>
    <Output mdxType="Output">color: #80AA01;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.c-error-500</Name>
    <Output mdxType="Output">color: #FF3C2B;</Output>
  </Property>
    </Reference>
    <Spacer my={8} mdxType="Spacer" />
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <span className="fs-body-3 d-block c-primary-500">Millimeter</span>
    <span className="fs-body-3 d-block c-secondary-500">Millimeter</span>
    <span className="fs-body-3 d-block c-tertiary-500">Millimeter</span>
    <span className="fs-body-3 d-block c-success-500">Millimeter</span>
    <span className="fs-body-3 d-block c-error-500">Millimeter</span>
  </Sandbox.Preview>
  <Sandbox.Code>
    <p className="c-primary-500">...</p>
    <p className="c-secondary-500">...</p>
    <p className="c-tertiary-500">...</p>
    <p className="c-success-500">...</p>
    <p className="c-error-500">...</p>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={8} mdxType="Spacer" />
    <p>{`Additionally, refer the color page of the utilities to see all possible colors of the palette.`}</p>
    <h2 {...{
      "id": "text-transform"
    }}>{`Text transform`}</h2>
    <p>{`This property specifies how to capitalize an element's text.`}</p>
    <Reference mdxType="Reference">
  <Property mdxType="Property">
    <Name mdxType="Name">.tt-normalcase</Name>
    <Output mdxType="Output">text-transform: normal;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.tt-uppercase</Name>
    <Output mdxType="Output">text-transform: uppercase;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.tt-lowercase</Name>
    <Output mdxType="Output">text-transform: lowercase;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.tt-capitalize</Name>
    <Output mdxType="Output">text-transform: capitalize;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.tt-unset</Name>
    <Output mdxType="Output">text-transform: unset;</Output>
  </Property>
    </Reference>
    <Spacer my={8} mdxType="Spacer" />
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <span className="fs-body-3 d-block tt-normalcase">millimeter</span>
    <span className="fs-body-3 d-block tt-uppercase">millimeter</span>
    <span className="fs-body-3 d-block tt-lowercase">millimeter</span>
    <span className="fs-body-3 d-block tt-capitalize">millimeter</span>
    <span className="fs-body-3 d-block tt-unset">millimeter</span>
  </Sandbox.Preview>
  <Sandbox.Code>
    <p className="tt-normalcase">...</p>
    <p className="tt-uppercase">...</p>
    <p className="tt-lowercase">...</p>
    <p className="tt-capitalize">...</p>
    <p className="tt-unset">...</p>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "whitespace"
    }}>{`whitespace`}</h2>
    <p>{`Defines how whitespace is handled inside an element.`}</p>
    <Reference mdxType="Reference">
  <Property mdxType="Property">
    <Name mdxType="Name">.ws-normal</Name>
    <Output mdxType="Output">whitespace: normal;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.ws-nowrap</Name>
    <Output mdxType="Output">whitespace: nowrap;</Output>
  </Property>
    </Reference>
    <Spacer my={8} mdxType="Spacer" />
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <span className="fs-body-2 d-block ws-normal">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua
    </span>
  </Sandbox.Preview>
  <Spacer my={4} mdxType="Spacer" />
  <Sandbox.Preview>
    <span className="fs-body-2 d-block ws-nowrap">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
    </span>
  </Sandbox.Preview>
  <Sandbox.Code>
    <p className="ws-normal">...</p>
    <p className="ws-nowrap">...</p>
  </Sandbox.Code>
    </Sandbox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      